import React, { useEffect, useMemo, useState, useRef } from "react";
import PageHeader from "../../components/PageHeader/PageHeader";
import { useNavigate, useLocation } from "react-router-dom";
import { FaEye, FaTimes } from "react-icons/fa";
import CommonTable from "../../components/CommonTable/CommonTable";
import { URLS } from "../../Services/Constant";
import { get, post } from "../../Services/ApiHandler";
import "./PinCode.css";
import moment from "moment/moment";
import usePermission from "../../customHook/usePermission";
import StatusModal from "../../components/StatusModal/StatusModal";

const PinCodeUser = () => {
  const location = useLocation();
  const [users, setUsers] = useState([]);
  const getPersistedPage = () => {
    const storedPage = sessionStorage.getItem("pincodeUserPage");
    return location?.state?.page || (storedPage ? Number(storedPage) : 1);
  };
  const getPersistedId = () => {
    return location?.state?.id || sessionStorage.getItem("pincodeUserId") || "";
  };
  const [page, setPage] = useState(getPersistedPage());
  const [searchText, setSearchText] = useState("");
  const [totalCount, setTotalCount] = useState(0);
  const [pagination, setPagination] = useState(null);
  const [address, setAddress] = useState("");
  const [popup, setPopup] = useState(false);
  const navigate = useNavigate();
  const permission = usePermission();

  const pageRef = useRef(page);

  const [idValue, setIdValue] = useState(getPersistedId());

  useEffect(() => {
    pageRef.current = page;
  }, [page]);

  useEffect(() => {
    sessionStorage.setItem("pincodeUserPage", String(page || 1));
  }, [page]);

  useEffect(() => {
    if (location?.state?.id) {
      setIdValue(location.state.id);
      sessionStorage.setItem("pincodeUserId", location.state.id);
    }
  }, [location?.state?.id]);

  useEffect(() => {
    if (location?.state?.page) {
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, []);
  console.log("pageRef.current", pageRef.current);

  const handleView = async (row) => {
    console.log("ROW DATA:", row);

    if (row?.id) {
      navigate("/pincode-view", {
        state: { id: row?.id, page: pageRef.current },
      });
    }
  };

  const handleStatusView = async (row) => {
    if (row?.id) {
      const res = await get(`${URLS.USERADDRESS}${row?.id}/`);
      console.log("resadders", res);
      if (res?.status === "success") {
        setAddress(res);
        setPopup(true);
      }
    }
  };

  const columns = useMemo(() => {
    let d = [
      {
        Header: "S.No",
        accessor: "sno",
        disableSortBy: true,
        width: "1%",
        Cell: ({ row }) => {
          return (
            <span className="sno">
              {String((row?.index || 0) + 1 + (page - 1) * 10).padStart(2, "0")}
            </span>
          );
        },
      },
      {
        Header: "User ID",
        accessor: "id",
        width: "70%",
        Cell: ({ value }) => {
          return <p className="mb-0">{value || "N/A"}</p>;
        },
      },
      {
        Header: "User Name",
        accessor: "name",
        width: "70%",
        Cell: ({ value }) => {
          return <p className="mb-0">{value || "N/A"}</p>;
        },
      },
      {
        Header: "Mobile Number",
        accessor: "mob_no",
        width: "70%",
        Cell: ({ value }) => {
          return <p className="mb-0">{value || "N/A"}</p>;
        },
      },
      {
        Header: "Lati / Long",
        // accessor: "lat",
        width: "70%",
        Cell: ({ row }) => {
          const data = row?.original;
          return (
            <p className="mb-0">
              {`${data?.latitude}/${data?.longitude}` || "N/A"}
            </p>
          );
        },
      },
    ];

    return [...d];
  }, [page]);

  const handleClearSearch = () => {
    setSearchText("");
    setPage(1);
  };

  const fetchUsers = async () => {
    try {
      let res = await get(`${URLS.PINCODEUSER}${idValue}/?page=${page || 1}`);
      console.log("Users list res:", res);
      if (res?.status === "success") {
        setUsers(res?.data || []);
        setTotalCount(res?.count || 0);
        setPagination({
          current_page: res?.current_page || 1,
          last_page: res?.total_pages || 1,
        });
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, [page, searchText]);

  return (
    <>
      <PageHeader title="PinCode Management" showBackButton={true} />
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <h2 style={{ fontSize: "20px", fontWeight: "600", color: "#7a52ab" }}>
          Total: {totalCount || 0}
        </h2>
        {/* <div className="search-wrapper">
                    <input
                        type="text"
                        placeholder="Search"
                        className="search-input"
                        value={searchText || ""}
                        onChange={(e) => {
                            setSearchText(e.target.value);
                            setPage(1);
                        }}
                    />
                    {searchText && (
                        <FaTimes
                            className="search-clear-icon"
                            onClick={handleClearSearch}
                        />
                    )}
                </div> */}
      </div>
      <CommonTable
        columns={columns}
        data={users || []}
        pagecount={pagination}
        setPageno={setPage}
        pageno={page || 1}
      />
      <StatusModal
        isOpen={popup}
        onClose={() => setPopup(false)}
        message={address?.address}
        time={address?.last_click_update}
      />
    </>
  );
};

export default PinCodeUser;
